import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    group: "Ordering & Shipping",
    items: [
      ["How long does delivery take?", "Standard delivery within South Africa takes 3–5 business days. Express is 1–2 business days. International orders take 7–14 business days depending on customs."],
      ["How much is shipping?", "Standard shipping is R 150 nationwide, free over R 2 000. Express is R 350. International shipping is calculated at checkout."],
      ["Do you ship internationally?", "Yes, we ship to most countries. Duties and customs are calculated and collected at checkout where possible."],
      ["Can I change my address after ordering?", "Yes, contact us within 12 hours of ordering and we'll update it before fulfillment."],
    ],
  },
  {
    group: "Wigs & Care",
    items: [
      ["Are these wigs real human hair?", "Most of our wigs are 100% human hair. Where a product is a human-hair blend, this is clearly labelled."],
      ["How do I install a glueless wig?", "Slip on, adjust the elastic band behind your ears, tighten the adjustable strap inside the cap, and lay any baby hairs. Watch our 60-second guide in the Wig Care section."],
      ["Can I dye or bleach the wig?", "Our 100% human hair pieces can be dyed and lifted. We recommend a professional stylist for major colour changes."],
      ["How long do the wigs last?", "Human-hair wigs last 12–18 months with proper care. Blends last 6–9 months."],
    ],
  },
  {
    group: "Returns & Exchanges",
    items: [
      ["What is your return policy?", "Uncut, unworn lace wigs may be exchanged within 30 days of delivery. Once the lace is cut or hair is altered, it is no longer eligible for return."],
      ["How do I exchange a wig?", "Contact hello@maisonluxe.co.za with your order number. Our concierge will guide you through the process and arrange courier collection."],
      ["When will I be refunded?", "Approved refunds are processed within 5 business days back to your original payment method."],
    ],
  },
  {
    group: "Payments",
    items: [
      ["What payment methods do you accept?", "Yoco, PayFast, Ozow, Payflex (pay-in-4), Visa, Mastercard, Apple Pay and Google Pay."],
      ["Is checkout secure?", "Yes – all transactions are PCI-DSS encrypted. We never store your full card details."],
      ["Can I pay in installments?", "Yes – Payflex lets you pay in 4 interest-free installments at checkout."],
    ],
  },
];

export default function FAQ() {
  const [open, setOpen] = useState({});

  return (
    <div data-testid="faq-page" className="max-w-4xl mx-auto px-6 py-20">
      <p className="small-label">Help centre</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-3">Questions, answered.</h1>

      <div className="mt-12 space-y-12">
        {FAQS.map((group, gi) => (
          <div key={gi}>
            <p className="font-serif text-2xl">{group.group}</p>
            <div className="mt-4 divide-y divide-stone-line border-y border-stone-line">
              {group.items.map(([q, a], i) => {
                const key = `${gi}-${i}`;
                const isOpen = open[key];
                return (
                  <div key={key} className="py-5">
                    <button
                      onClick={() => setOpen({ ...open, [key]: !isOpen })}
                      data-testid={`faq-${gi}-${i}`}
                      className="w-full flex items-center justify-between text-left text-sm gap-4"
                    >
                      <span className="font-medium">{q}</span>
                      <ChevronDown strokeWidth={1.5} className={`w-4 h-4 shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                    </button>
                    {isOpen && <p className="text-sm text-stone leading-relaxed mt-3">{a}</p>}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
